import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { AxiosError } from 'axios';

import { axiosClient } from '@/lib/axios';

export const verifyPromoCode = async ({
  code,
  planID,
}: {
  planID: number;
  code: string;
}): Promise<{ price: number }> => {
  const { data } = await axiosClient.put<{ price: number }>(`/premium/plans/${planID}/promo-code/apply`, {
    code,
  });
  return data;
};

type UseVerifiyPromoCodeOptions = {
  config?: Partial<
    UseMutationOptions<
      { price: number },
      AxiosError<{ message: string }>,
      {
        planID: number;
        code: string;
      }
    >
  >;
  postSuccess: () => void;
  handleAfterFailure: (code?: number) => void;
};

export const useVerifiyPromoCode = ({ config, postSuccess, handleAfterFailure }: UseVerifiyPromoCodeOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.response?.data.message,
      });
      handleAfterFailure(error.response?.status);
    },
    onSuccess: () => {
      postSuccess();
    },
    ...config,
    mutationFn: verifyPromoCode,
  });
};
